import { useEffect, useState } from 'react';
import { useEventCallback } from '../../hooks/use-event-callback';
import { useCastContext } from '../cast-context';

export interface RemotePlayerEventOptions {}

export function useRemotePlayerEvent(
  event: `${cast.framework.RemotePlayerEventType}`,
  callback: (event: cast.framework.RemotePlayerChangedEvent) => void,
) {
  const { player } = useCastContext();
  const [controller] = useState(() => (player ? new cast.framework.RemotePlayerController(player) : undefined));
  const eventCallback = useEventCallback(callback);

  useEffect(() => {
    if (controller) {
      controller.addEventListener(cast.framework.RemotePlayerEventType[event], eventCallback);

      return () => {
        controller.removeEventListener(cast.framework.RemotePlayerEventType[event], eventCallback);
      };
    }
  }, [controller, event, eventCallback]);
}
